import { FeatureKey } from '@/types/Licensing.interface';

/**
 * Sidebar visibility rules, shared by the menu tree, the menu search and the
 * Ctrl+K palette. `tokenBranchId` is the branch in the access token: a company
 * admin with a branch selected is in branch view.
 */

// An employee has no backend read rule for these pages (employee CASL
// policies), so opening them only answered 403 "Gerekli izinlere sahip
// değilsiniz". Hide them from the employee's menu.
export const EMPLOYEE_HIDDEN_PATHS = [
  '/management/stock',
  '/management/warehouses',
  '/management/recipes',
  '/management/stamp-cards'
];

export const isHiddenForEmployee = (
  role: string | null,
  path: string
): boolean => role === 'EMPLOYEE' && EMPLOYEE_HIDDEN_PATHS.includes(path);

/** Role rule for a menu key (e.g. 'companies', 'plans'). */
export function shouldShowMenuItem(
  role: string | null,
  tokenBranchId: number | null | undefined,
  menuItem: string
): boolean {
  if (!role) return false;

  if (role === 'SUPER_ADMIN') return true;

  if (role === 'COMPANY_ADMIN') {
    // Always hide companies
    if (['companies'].includes(menuItem)) return false;

    // Branch View - hide branches, plans, subscriptions, sms-packages, loyalty-settings
    if (
      tokenBranchId &&
      [
        'branches',
        'plans',
        'subscriptions',
        'sms-packages',
        'loyalty-settings'
      ].includes(menuItem)
    ) {
      return false;
    }

    return true;
  }

  if (role === 'BRANCH_ADMIN') {
    return ![
      'companies',
      'branches',
      'plans',
      'subscriptions',
      'adisyo',
      'loyalty-settings'
    ].includes(menuItem);
  }

  return false;
}

/** A plan feature the current branch lacks (shown locked in the menu). */
export function isFeatureLocked(
  role: string | null,
  tokenBranchId: number | null | undefined,
  hasFeature: (feature: FeatureKey) => boolean,
  feature: FeatureKey
): boolean {
  if (role === 'SUPER_ADMIN') return false;

  // Admin view (no branch selected) - don't lock features for COMPANY_ADMIN
  if (role === 'COMPANY_ADMIN' && !tokenBranchId) return false;

  return !hasFeature(feature);
}
